
function productPrelaunchKlaviyo(){

    const prelaunchWaitlist = document.querySelectorAll('.js-prelaunch-waitlist');
    if(!prelaunchWaitlist) return;

    prelaunchWaitlist.forEach(block=>{
        const klaviyoForm = block.querySelector('.prelaunch-klaviyo-form');
        const remindButton = block.querySelector('.js-prelaunch-waitlist-remind-button');
        let klaviyoInput;
        if(!klaviyoForm) return;

        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    const successMessage = klaviyoForm.querySelector('span');
                    if (successMessage && successMessage.textContent === 'Thank You') {
                        productPrelaunchKlaviyoSuccess(block)
                        observer.disconnect();
                    }
                    if (klaviyoInput === undefined ) {
                        klaviyoInput = klaviyoForm.querySelector('input[type="email"]');
                        productPrelaunchListenerInput(klaviyoInput,remindButton)
                    }


                }
            });
        });
        const config = { childList: true, subtree: true };
        observer.observe(klaviyoForm, config);
    })
}
productPrelaunchKlaviyo();

function productPrelaunchKlaviyoSuccess(block) {
    const klaviyoForm = block.querySelector('.prelaunch-klaviyo-form');
    const klaviyoFormSuccess = block.querySelector('.js-prelaunch-waitlist-success');
    const remindButton = block.querySelector('.js-prelaunch-waitlist-remind-button');
    const remindSuccess = block.querySelector('.js-prelaunch-waitlist-remind-success');
    const info = block.querySelector('.prelaunch-waitlist-date-info');
    const infoSucsess = block.querySelector('.prelaunch-waitlist-date-info-sucsess');

    klaviyoForm.classList.add("hidden");
    klaviyoFormSuccess.classList.remove("hidden");
    info?.classList.add("hidden");
    infoSucsess?.classList.remove("hidden");
    remindButton?.addEventListener("click", ()=>{
        productPrelaunchRemindSuccess(remindButton,remindSuccess)
        productPrelaunchOpenCalendar(remindButton);
    })
}
function productPrelaunchRemindSuccess(remindButton,remindSuccess) {
    remindButton.classList.add("hidden");
    remindSuccess.classList.remove("hidden");
}
function  productPrelaunchOpenCalendar(remindButton) {


    const title = remindButton.getAttribute("data-calendar-title");
    const dateTime = remindButton.getAttribute("data-calendar");
    const mailSystem = remindButton.getAttribute("data-mail-system");

    if (!dateTime) {
        alert("The date and time of the event are not specified");
        return;
    }

    const dateParts = dateTime.split(' ')[0].split('-');
    const timeParts = dateTime.split(' ')[1].split(':');

    if (!dateParts || !timeParts || dateParts.length !== 3 || timeParts.length !== 2) {
        alert("Invalid date and time format. Use the format: YYYY-MM-DD HH:MM.");
        return;
    }

    const year = dateParts[0];
    const month = dateParts[1].padStart(2, '0');
    const day = dateParts[2].padStart(2, '0');
    const hour = timeParts[0].padStart(2, '0');
    const minute = timeParts[1].padStart(2, '0');
    const formattedDate = `${year}${month}${day}T${hour}${minute}00`;

    function formatDateOutlook(input) {
        let year = input.slice(0, 4);
        let month = input.slice(4, 6);
        let day = input.slice(6, 8);
        let hour = input.slice(9, 11);
        let minute = input.slice(11, 13);
        let second = input.slice(13, 15);
        return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
    }

    let calendarURL = "";

    switch(mailSystem) {
        case "gmail.com":
            calendarURL = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${formattedDate}/${formattedDate}&details=&location=&sf=true&ctz=Europe/London&output=xml`;
            break;
        case "outlook.com":
            calendarURL = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&startdt=${formatDateOutlook(formattedDate)}&enddt=${formatDateOutlook(formattedDate)}&subject=${encodeURIComponent(title)}&starttz=Europe/London&endtz=Europe/London`;
            break;
        case "hotmail.com":
            calendarURL = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&startdt=${formatDateOutlook(formattedDate)}&enddt=${formatDateOutlook(formattedDate)}&subject=${encodeURIComponent(title)}&starttz=Europe/London&endtz=Europe/London`;
            break;
        default:
            calendarURL = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${formattedDate}/${formattedDate}&details=&location=&sf=true&ctz=Europe/London&output=xml`;
            break;
    }
    window.open(calendarURL, '_blank');
}
function productPrelaunchListenerInput(klaviyoInput, remindButton) {
    function extractDomain(email) {
        const domain = email.split('@')[1];
        return domain ? domain : '';
    }

    klaviyoInput.addEventListener('input', function () {
        const emailValue = klaviyoInput.value;
        const domain = extractDomain(emailValue);
        if (domain) {
            remindButton?.setAttribute('data-mail-system', domain);
        } else {
            remindButton?.removeAttribute('data-mail-system');
        }
    });
}
function initTimelinePopup() {
    const timelineButtons = document.querySelectorAll('.js-timeline-button');
    const timelinePopup = document.querySelector('.js-timeline-popup');
    const closeButton = timelinePopup?.querySelector('.js-timeline-close');
    const ANIMATION_DELAY = 50; // milliseconds

    if (!timelinePopup || !timelineButtons.length) return;

    function openTimelinePopup(e) {
        e.preventDefault()
        document.body.style.overflow = 'hidden';
        timelinePopup.classList.add('open');
        setTimeout(() => {
            timelinePopup.classList.add('animate');
        }, ANIMATION_DELAY);

        reinitTimelineContent()
    }

    function closeTimelinePopup() {
        document.body.style.overflow = '';
        timelinePopup.classList.remove('animate');
        setTimeout(() => {
            timelinePopup.classList.remove('open');
        }, 300); // match transition duration
    }

    // Add event listeners
    timelineButtons.forEach(button => {
        button.addEventListener('click', openTimelinePopup);
    });

    closeButton?.addEventListener('click', closeTimelinePopup);

    // Close on overlay click
    timelinePopup.addEventListener('click', (e) => {
        if (e.target === timelinePopup) {
            closeTimelinePopup();
        }
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && timelinePopup.classList.contains('open')) {
            closeTimelinePopup();
        }
    });
}

initTimelinePopup();

function reinitTimelineContent(){
    const timelinesSection = document.querySelector(".shopify-section--timelines");
    if (timelinesSection) {
        const timeline = document.querySelector(".timelines__timeline-content");
        const timelineLine = document.querySelector(".timelines__timeline-line");
        timelineLine.style.width = timeline.scrollWidth + 'px';

        const timelineContent = document.querySelector('.timelines__timeline-content-wrap');
        const buttonsWrap = document.querySelector('.timelines__buttons-wrap');
        const buttonPrev = document.querySelector('.timelines__button--prew');
        const buttonNext = document.querySelector('.timelines__button--next');

        const scrollDistance = 250;

        if (timelineContent.scrollWidth > timelineContent.clientWidth) {
            function scrollContent(direction) {
              
                let scrollOn = scrollDistance;
                if (direction === 'next') {
                    
                    if((timelineContent.scrollLeft + scrollDistance) > (timelineContent.scrollWidth - timelineContent.offsetWidth)){
                        scrollOn = (timelineContent.scrollWidth - timelineContent.offsetWidth) - timelineContent.scrollLeft;
                       buttonNext.classList.add('disabled');
                    }else{
                        buttonNext.classList.remove('disabled');
                    }
                    buttonPrev.classList.remove('disabled');
                    timelineContent.scrollBy({ left: scrollOn, behavior: 'smooth' });
                } else if (direction === 'prev') {
                    if(timelineContent.scrollLeft < scrollDistance){
                        scrollOn = scrollDistance - (scrollDistance - timelineContent.scrollLeft)
                        buttonPrev.classList.add('disabled');
                    }else{
                        buttonPrev.classList.remove('disabled');
                    }
                    buttonNext.classList.remove('disabled');
                    
                    timelineContent.scrollBy({ left: -scrollOn, behavior: 'smooth' });
                }
                // setTimeout(checkButtonsState, 100);
            }
            function checkButtonsState() {
                 
                if (timelineContent.scrollLeft + timelineContent.clientWidth >= timelineContent.scrollWidth - 10) {
                    buttonNext.classList.add('disabled');
                    buttonNext.setAttribute("disabled", "");
                } else {
                    buttonNext.classList.remove('disabled');
                    buttonNext.removeAttribute("disabled");
                }
                if (timelineContent.scrollLeft === 0) {
                    buttonPrev.classList.add('disabled');
                    buttonNext.setAttribute("disabled", "");
                } else {
                    buttonPrev.classList.remove('disabled');
                    buttonNext.removeAttribute("disabled");
                }
            }

            buttonNext.addEventListener('click', () => scrollContent('next'));
            buttonPrev.addEventListener('click', () => scrollContent('prev'));

            const onIntersect = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        timelineContent.scrollLeft = timelineContent.scrollWidth;
                        setTimeout(() => {
                            checkButtonsState();
                        }, 800);
                        observer.unobserve(entry.target);
                    }
                });
            };
            const observer = new IntersectionObserver(onIntersect, {
                root: null,
                rootMargin: '0px',
                threshold: 0.85
            });
            if (timelineContent) {
                observer.observe(timelineContent);
            }
            buttonsWrap.classList.remove('hidden');
            checkButtonsState();
        } else {

            buttonsWrap.classList.add('hidden');
        }
    }
}